import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Card, CardBody, Col, Row,
} from 'reactstrap';
import ReactTableBase from 'src/shared/components/table/ReactTableBase';
import { useTranslation } from 'react-i18next';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import AccountCreationModal from '../../components/AccountCreationModal';
import { Tooltip } from '@mui/material';
import { reduxForm } from 'redux-form';


const UserListTableView = ({ reactTableData, isNoRecordFound }) => {
  const [rows] = useState(reactTableData && reactTableData?.tableRowsData ? reactTableData.tableRowsData : null);
  const { t } = useTranslation('common');
  const [isTitle, setTitle] = useState(null);


  const tableConfig = {
    isEditable: false,
    isSortable: true,
    isResizable: true,
    withPagination: true,
    withSearchEngine: true,
    manualPageSize: [10, 50, 100, 1000],
    placeholder: 'Search by Name, User Name, Email ID...',
  };

  const [viewDetailPopup, setViewDetailPopup] = useState(false);

  const Add = () => {
    setViewDetailPopup(true);
    setTitle("Create New Account");
  }

  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody>
          <Row>
            <Col md={12}>
              <h3 className="page-title">Merchant Account Details</h3>
            </Col>
          </Row>
          <Tooltip title="Add New Account Details">
            <Fab size="large" color="primary" aria-label="add" style={{ float: "right", backgroundColor: "#32CA73", color: "white" }} onClick={() => Add()}>
              <AddIcon />
            </Fab>
          </Tooltip>
          {!isNoRecordFound && rows &&
            <ReactTableBase
              name={t('instution_type.modify.name_map')}
              key={'searchable'}
              columns={reactTableData.tableHeaderData}
              data={rows}
              tableConfig={tableConfig}
            />
          }
          {viewDetailPopup &&
            <AccountCreationModal isTitle={isTitle}
              modalShow={viewDetailPopup}
              setModalShow={setViewDetailPopup} />}


        </CardBody>
      </Card>
    </Col>
  );
};

UserListTableView.propTypes = {
  reactTableData: PropTypes.shape({
    tableHeaderData: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      name: PropTypes.string,
    })),
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
  }).isRequired,
};

export default (reduxForm({ form: 'UserListTableViewForm', enableReinitialize: true })(UserListTableView))
